import * as achTransactionGrid from '../store/achTransactionGrid';
import * as administration from '../store/administration';
import * as authentication from '../store/authentication';
import * as balancetransaction from '../store/balancetransaction';
import * as grids from '../store/grids';
import * as infrastructure from '../store/infrastructure';
import * as payments from '../store/payments';
import * as messages from '../store/messages';
import * as passthru from '../store/passthru';
import * as snackbar from '../store/snackbar';
import * as userEmulation from '../store/userEmulation';
import * as infuse from '../store/infuse';
import * as _tabs from '../store/_tabs';
import * as sso from '../store/sso';

// Load reducers

const mapReducers = (section) => {
  const keys = Object.keys(section);
  const mapped = keys.map((x) => ({
    [x]: section[x].reducers
  }));

  return mapped.reduce((acc, o) => ({ ...acc, ...o }), {});
};

// eslint-disable-next-line import/prefer-default-export
export const reducers = {
  achTransactionGrid: achTransactionGrid.reducers,
  auth: authentication.reducers,
  administration: mapReducers(administration),
  balancetransaction: mapReducers(balancetransaction),
  grids: grids.reducers,
  infrastructure: infrastructure.reducers,
  payments: payments.reducers,
  passthru: passthru.reducers,
  snackbar: snackbar.reducers,
  sso: sso.reducers,
  tabs: _tabs.reducers,
  infuse: infuse.reducers,
  messages: messages.reducers,
  userEmulation: userEmulation.reducers
};

export const epics = {
  ...authentication.epics,
  // TODO: extra compose for nested epics
  ...infrastructure.epics,
  ...infuse.epics,
  ...sso.epics
};
